import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/ja'

moment.locale('ja')

Vue.filter('formatDate', (date, format = 'YYYY/MM/DD', timezone = 'Asia/Tokyo') => {
  return date ? moment(date).format(format) : null
})
